import { render, staticRenderFns } from "./leaderFreeAct.vue?vue&type=template&id=798a3e4b&scoped=true&"
import script from "./leaderFreeAct.vue?vue&type=script&lang=js&"
export * from "./leaderFreeAct.vue?vue&type=script&lang=js&"
import style0 from "./leaderFreeAct.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./leaderFreeAct.vue?vue&type=style&index=1&id=798a3e4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798a3e4b",
  null
  
)

component.options.__file = "leaderFreeAct.vue"
export default component.exports